"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("../styles");
var _getTitle = _interopRequireDefault(require("../lib/getTitle"));
const SingleSelect = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    label,
    placeholder,
    options = [],
    name,
    value,
    errors,
    id,
    className,
    style,
    disabled = false,
    onChange,
    ...props
  } = _ref;
  const uniqueId = id || name || label;
  const errorsSectionId = uniqueId ? `${uniqueId}-errors` : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: className,
    ref: ref
  }, label && /*#__PURE__*/_react.default.createElement(_styles.StyledLabel, {
    htmlFor: name
  }, label), /*#__PURE__*/_react.default.createElement(_styles.SingleSelectStyle, (0, _extends2.default)({
    id: name,
    name: name,
    value: value || '',
    title: (0, _getTitle.default)(value, options, placeholder),
    style: style,
    containsErrors: errors && errors.length > 0,
    disabled: disabled,
    placeholderSelected: value === '',
    onChange: onChange,
    "aria-describedby": errorsSectionId
  }, props), placeholder && /*#__PURE__*/_react.default.createElement("option", {
    key: "placeholder",
    value: "",
    disabled: true
  }, placeholder), options && (0, _map.default)(options).call(options, _ref2 => {
    let {
      label,
      value
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("option", {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/_react.default.createElement(_styles.StyledErrorContainer, {
    id: errorsSectionId
  }, errors && (0, _map.default)(errors).call(errors, error => /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, {
    key: error
  }, error))));
});
SingleSelect.propTypes = {
  /**
   * A label string.
   */
  label: _propTypes.default.string,
  /**
   * A placeholder string. This will be rendered as a disabled (non-selectable) option.
   */
  placeholder: _propTypes.default.string,
  /**
   * A list of objects containing the label and value corresponding to the select's options.
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })),
  name: _propTypes.default.string,
  /**
   * The available types for the value prop correspond to the available types for value in an options object.
   */
  value: function (props, propName) {
    if (!props.placeholder && !props[propName]) {
      return new Error("A non-falsy value prop is required when no placeholder prop is provided. Otherwise the select's displayed value will likely not match the value in state.");
    }
    if (typeof props[propName] !== 'string' && typeof props[propName] !== 'number' && props[propName] !== null) {
      return new Error(`You have provided a value prop of type ${typeof props[propName]}. Value should be a string or number or null.`);
    }
  },
  /**
   * A list of errors as strings for the input to render.
   */
  errors: _propTypes.default.arrayOf(_propTypes.default.string),
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  /**
   * onChange prop to control this component
   */
  onChange: _propTypes.default.func.isRequired,
  'aria-label': _propTypes.default.string
};
SingleSelect.displayName = 'SingleSelect';
var _default = exports.default = SingleSelect;
SingleSelect.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleSelect",
  "props": {
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "A list of objects containing the label and value corresponding to the select's options.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "label": {
              "name": "string",
              "required": true
            },
            "value": {
              "name": "union",
              "value": [{
                "name": "string"
              }, {
                "name": "number"
              }],
              "required": true
            }
          }
        }
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "A label string.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholder": {
      "description": "A placeholder string. This will be rendered as a disabled (non-selectable) option.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "name": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "description": "The available types for the value prop correspond to the available types for value in an options object.",
      "type": {
        "name": "custom",
        "raw": "function (props, propName) {\n  if (!props.placeholder && !props[propName]) {\n    return new Error(\n      \"A non-falsy value prop is required when no placeholder prop is provided. Otherwise the select's displayed value will likely not match the value in state.\"\n    );\n  }\n  if (\n    typeof props[propName] !== 'string' &&\n    typeof props[propName] !== 'number' &&\n    props[propName] !== null\n  ) {\n    return new Error(\n      `You have provided a value prop of type ${typeof props[\n        propName\n      ]}. Value should be a string or number or null.`\n    );\n  }\n}"
      },
      "required": false
    },
    "errors": {
      "description": "A list of errors as strings for the input to render.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "style": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "onChange": {
      "description": "onChange prop to control this component",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "aria-label": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};